export const PHONE_DISPLAY = "(801) 400-3346";
export const PHONE_LINK = "tel:+18014003346";
export const EMAIL = "scottysdetail@gmail.com";
export const EMAIL_LINK = `mailto:${EMAIL}`;
export const BUSINESS_NAME = "Scotty's Land Specialist LLC";
export const SLOGAN = "WE LOVE DIRT!";
export const HOURS = "Mon–Fri, 11:00 AM – 7:00 PM";
export const HOME_BASE = "Highland, Utah";

export const BUSINESS_ADDRESS = "Highland, UT";

// Shown directly beneath every phone button.
export const PHONE_TAGLINE = "We text 24/7";

export const quoteServiceOptions = [
  "Snow Removal",
  "Fall Cleanup",
  "Land Clearing",
  "Weed Control",
  "Dumpster Rental",
  "Spring Cleanup",
  "Junk Removal",
];

export const GOOGLE_MAPS_URL =
  "https://maps.google.com/maps/place/Scottys+Land+Specialist/@40.419158,-111.820585,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x5AA9F26DE680491F!8m2!3d40.419158!4d-111.820585";

export const whyChooseUs = [
  {
    icon: "MessageSquare",
    title: "Talk Directly with the Team",
    description:
      "You work with the team, not a call center. Clear, direct communication from first call to finished job.",
  },
  {
    icon: "MapPin",
    title: "Locally Owned in Highland",
    description:
      "Based in Highland, Utah, we know the area and the seasons. Local service from a neighbor.",
  },
  {
    icon: "Building2",
    title: "Residential & Commercial",
    description:
      "Property services for homes and businesses — one local contact for the whole project.",
  },
  {
    icon: "Layers",
    title: "Four-Season Service",
    description:
      "Spring, summer, fall, and winter — we help keep your property clean and usable all year.",
  },
  {
    icon: "HeartHandshake",
    title: "Care for Every Property",
    description:
      "We treat each property with care and focus on dependable, honest work from start to finish.",
  },
];
